import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function ServiceAreaMapSection() {
  const destinations = {
    column1: ['Church', 'Restaurants', 'Retail Stores', 'Mental Health', 'Social Functions', 'Family Functions'],
    column2: ['Physical Therapy', 'Prescriptions', 'Substance Treatment', 'Adult Day Care', 'Outpatient Procedures', "Doctor's Appointments"]
  };
  return <section className="bg-[#0B1F3A] text-white py-20" data-id="element-237">
      <div className="max-w-7xl mx-auto px-4" data-id="element-238">
        <div className="text-center mb-12" data-id="element-239">
          <h2 className="text-3xl lg:text-4xl font-bold mb-6" data-id="element-240">
            Serving Patients Across Maryland
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-241">
            We provide transportation to a wide variety of destinations to meet
            all your needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-242">
          <div className="space-y-4" data-id="element-243">
            {destinations.column1.map((destination, index) => <div key={index} className="flex items-center space-x-3 bg-white bg-opacity-10 rounded-lg p-4" data-id="element-244">
                <CheckCircleIcon className="h-6 w-6 text-[#E63946] flex-shrink-0" data-id="element-245" />
                <span className="text-lg" data-id="element-246">{destination}</span>
              </div>)}
          </div>
          <div className="space-y-4" data-id="element-247">
            {destinations.column2.map((destination, index) => <div key={index} className="flex items-center space-x-3 bg-white bg-opacity-10 rounded-lg p-4" data-id="element-248">
                <CheckCircleIcon className="h-6 w-6 text-[#E63946] flex-shrink-0" data-id="element-249" />
                <span className="text-lg" data-id="element-250">{destination}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}